import { createContext, useContext } from 'react';

type InvitePeopleDialogState =
    | 'main'
    | 'confirm'
    | 'confirm-max-capacity-reached'
    | 'confirm-capacity-increased'
    | 'capacity-reached';

const InvitePeopleContext = createContext<
    | {
          handleDialogStateChange: (state: InvitePeopleDialogState) => void;
          handleSave: (saveCallback: () => Promise<void>) => void;
          handleClose: () => void;
      }
    | undefined
>(undefined);

const useInvitePeopleContext = () => {
    const context = useContext(InvitePeopleContext);
    if (!context) throw new Error('useInvitePeopleContext must be used within a provider');
    return context;
};

export { InvitePeopleContext, useInvitePeopleContext };
export type { InvitePeopleDialogState };
